/*eslint-disable */
import { Box, IconButton, Tooltip } from "@mui/material"
import Datatable from "../../../../bmr/components/features/Datatable"
import { useState } from "react";
import { EyeIconButton } from "../../../../assets/common-svg/CommonSvg";
import { useLocation, useNavigate } from "react-router-dom";
import { masterKeys } from "../../../constants/constant";
import SubjectApi from "../../../../services/subjectService";
import { useSelector } from "react-redux";
import TaskFilter from "./filter";
import {capitalizeWords} from "../../../../utils/utils"

const DownloadCenter = () => {
    const { pathname } = useLocation();
    const [subjectData, setSubjectData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const naviagte = useNavigate()
    const slug = pathname?.split('/')?.filter(Boolean)?.pop();
    const title = masterKeys?.[slug]
    const userData = useSelector((state) => state.loginData);
    const role_id=userData.role_id
    const role_slug =userData.role_slug
    const userID=userData.loginId
    const [filters, setFilters] = useState({});
    const filterConfig = {
        product: {
            label: "Product",
            displayKey: "label"
        },
        phase: {
            label: "Phase",
            displayKey: "label"
        },
        investigator: {
            label: "Principal Investigator",
            displayKey: "label"
        },
        hospital: {
            label: "Hospital",
            displayKey: "label"
        }
    };


    const columns = [
        {
            id: 'patient_id',
            name: 'Patient ID',
            align: "center",
            selector: row => row.patient_id,
            sortable: true
        },
        {
            id: 'patient_name',
            name: 'Patient Name',
            align: "center",
            selector: row => capitalizeWords(row.first_name) + ' ' + capitalizeWords(row.last_name),
            sortable: true
        },
        {
            id: 'product',
            name: 'Product',
            align: "center",
            selector: row => capitalizeWords(row.product_name),
            sortable: true
        },
        {
            id: 'phase',
            name: 'Phase',
            align: "center",
            selector: row => capitalizeWords(row.phase_name),
            sortable: true
        },
        {
            id: 'hospital',
            name: 'Hospital',
            align: "center",
            selector: row => row.hospitalDetails.name,
            sortable: true
        },
        {
            id: 'investigator',
            name: 'PI',
            align: "center",
            selector: row => row.investigatorDetails.name,
            sortable: true
        },
        {
            name: 'Action',
            align: "center",
            selector: row => <Box key={row.id}>
                <Tooltip
                    title={
                        row?.feasibility_assessments?.qr_code_generations?.[0]?.id &&
                            row?.feasibility_assessments?.id
                            ? "View"
                            : "QR code / Feasibility not available"
                    }
                >
                    <span>
                        <IconButton
                            disabled={
                                !row?.feasibility_assessments?.qr_code_generations?.[0]?.id ||
                                !row?.feasibility_assessments?.id
                            }
                            onClick={() => {
                                const qrId =
                                    row?.feasibility_assessments?.qr_code_generations?.[0]?.id;
                                const feasibilityId = row?.feasibility_assessments?.id;

                                if (!qrId || !feasibilityId) return;

                                if (role_id === 5 || role_slug === 'project-manager') {
                                    naviagte(
                                        `/download-center/patient-details/${qrId}/${feasibilityId}`,
                                        { state: { row } }
                                    );
                                } else {
                                    naviagte(
                                        `/bmr/download-center/patient-details/${qrId}/${feasibilityId}`,
                                        { state: { row } }
                                    );
                                }
                            }}
                        >
                            {/* <EyeIconButton bgColor="#C3C3C3" /> */}
                            <EyeIconButton bgColor={ !row?.feasibility_assessments?.qr_code_generations?.[0]?.id ||
                                !row?.feasibility_assessments?.id ? "#C3C3C3": "#3571FF"} />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>


        },
    ];

    const handleServerSideChange = async (params, appliedFilters = filters) => {

        try {
            setIsLoading(true)
            const res = await SubjectApi.getSubjectList(
                appliedFilters.phase || "",              // phase_id
                params.page,
                params.per_page,
                params.search,
                role_id === 5 ? userID : "",             // editor_id
            "" ,  // investigator_id
                "",                                      // status
                "",                                       //gender
                "",                                        //order
                "",                                     //order_by
                role_id !== 5 ? userID : "",             // user_id
                appliedFilters.product || "",            // product
                appliedFilters.phase || "",               // phase
                appliedFilters.hospital || "",    //hospital
                 appliedFilters.investigator || "" ,//investigator

            );

            setSubjectData({ items: res?.data, total_count: res.page_details.no_of_records, page: res?.page_details.page, per_page: res?.page_details.limit })
        } catch (error) {
            console.error("Error fetching subject list:", error);
            setIsLoading(false)
        }
        finally {
            setIsLoading(false)
        }
    }

const updateFilter = (params) => {
    const {
        page = 1,
        per_page = 10,
        search = '',
        ...appliedFilters
    } = params;

    const isFilterChanged =
        JSON.stringify(filters) !== JSON.stringify(appliedFilters);

    const finalPage = isFilterChanged ? 1 : page;

    setFilters(appliedFilters);

    handleServerSideChange(
        { page: finalPage, per_page, search },
        appliedFilters
    );
};


    return <div className="!p-6">
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
            <Datatable
    columns={columns}
    data={subjectData}
    title={title}
    searchPlaceholder="Search by Patient Name"
    loading={isLoading}
    onServerSideChange={updateFilter}
    remote={true}
    FilterComponent={TaskFilter}
    filterConfig={filterConfig}
/>

        </div>
    </div>
}
export default DownloadCenter;